/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { observable, action } from "mobx";
import { appIdentifiers } from "constants/enums";

class TopbarStore {
  @observable config;
  @observable showSearchInTopbar = true;

  constructor() {
    this.init();
  }

  initStore(docApi, stores) {
    if (docApi) {
      this.docApi = docApi;
    }
    if (stores) {
      this.stores = stores;
    }
  }

  @action
  init() {
    this.config = {};
  }

  @action.bound
  setTopbarConfig(config) {
    this.config = Object.assign({}, this.config, config);
  }

  @action.bound
  setSearchUIVisibility(visible) {
    this.showSearchInTopbar = visible;
  }

  @action.bound
  customizeTopBarComponent(componentName, config) {
    if (componentName === appIdentifiers.SEARCH) {
      this.setSearchUIVisibility(config.visible);
    }
  }
}

export { TopbarStore };
